<template>
	<ManagingSection class="list-container" :isTable="true">
		<template slot="infoSection">
			<div class="section__info__left list-container__total">
				검색결과 {{ contentTotal | currency }} 건
			</div>
			<div class="section__info__right">
				<label class="section__info__items btn orange">
					인스타그램 마이그레이션
					<input
						v-show="false"
						type="file"
						accept="application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
						@change="instaMigration"
					/>
				</label>
				<button
					class="btn-excel section__info__items"
					type="button"
					@click="excelDown"
				>
					엑셀 다운로드
				</button>
				<select
					class="select section__info__items"
					:value="order"
					@change="
						changeImmediately({
							key: 'order',
							value: $event.target.value,
						})
					"
				>
					<option
						v-for="item in orderList"
						:key="item.id"
						:value="item.id"
					>
						{{ item.text }}
					</option>
				</select>
				<select
					class="select section__info__items"
					:value="limit"
					@change="
						changeImmediately({
							key: 'limit',
							value: $event.target.value,
						})
					"
				>
					<option
						v-for="item in limitList"
						:key="item.id"
						:value="item.id"
					>
						{{ item.name }}
					</option>
				</select>
			</div>
		</template>
		<slot />
		<PaginationBox
			v-if="list.length > 0"
			@to="changeImmediately({ key: 'offset', value: $event.offset })"
			:totalItem="contentTotal"
			:limit="limit"
			:offset="offset"
			:pageLengPerOne="10"
			slot="pagination"
		/>
	</ManagingSection>
</template>

<script>
	import { mapState, mapGetters } from 'vuex';
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import PaginationBox from '@/components/PaginationBox.vue';

	export default {
		name: 'ListContainer',
		components: { ManagingSection, PaginationBox },
		computed: {
			...mapState('register', [
				'beforeParams',
				'orderList',
				'order',
				'limit',
				'offset',
				'contentTotal',
				'list',
			]),
			...mapGetters(['getLimitList']),
			limitList() {
				return this.getLimitList(50);
			},
		},
		methods: {
			async instaMigration(e) {
				const file = e.target.files[0];
				e.target.value = null;
				if (
					!confirm(
						`해당 파일로 인스타그램 마이그레이션 진행하겠습니까? ${file.name}`
					)
				)
					return;
				try {
					const formData = new FormData();
					formData.append('file', file);
					await this.$axiosAdmin2.post(
						'/api/registers/external-advertising-upload',
						formData,
						{
							headers: {
								'Content-Type': 'multipart/form-data',
							},
						}
					);
					alert('인스타그램 마이그레이션 성공!');
				} catch (err) {
					const message =
						err.response.data.message ||
						'인스타그램 마이그레이션 실패!!';
					alert(message);
				}
			},
			changeImmediately({ key, value }) {
				const query = _.cloneDeep(this.$route.query);
				query[key] = value;
				if (key === 'limit') query.offset = 0;
				this.$router.push({ query }).catch(err => {
					window.location.reload();
				});
			},
			excelDown() {
				const params = this.beforeParams;
				this.$store.commit('modal/toggleModal', {
					id: 'ExcelDownList',
					params: {
						total: this.contentTotal,
						type: 'register',
						params,
					},
				});
			},
		},
	};
</script>

<style lang="scss" scoped>
	.list-container {
		.list-container__total {
			font-weight: 700 !important;
		}
	}
</style>
